const MENU_LIST = {
    VENDOR_MENU: [
        {
            name:	'発注状況'
        ,	link:	'/unofficialNoticeOrder'
        }
    ]
    
,   HEAD_MENU: [
        {
            name:	'生産基礎データ'
        ,	link:	'/productionStandardData'
        }
    ,	{
            name:	'マスター'
        ,	list:	[
                        {
                            name:	'商品マスター'
                        ,	link:	'/headMasterItem'
                        }
                    ,	{
                            name:	'部材換算マスター'
                        ,	list:	[
                                        {
                                            name:	'通常'
                                        ,	link:	'/headMasterMaterialsConversionNormal'
                                        }
                                    ,	{	
                                            name:	'逆引き'
                                        ,	link:	'/headMasterMaterialsConversionReverseResolution'
                                        }
                                    ]
                        }
                    ,	{
                            name:	'カテゴリーマスター'
                        ,	link:	'/headMasterCategory'
                        }
                        // 2024年6月21日 竹田 カテゴリー別商品按分マスター追加
                    ,	{
                            name:	'カテゴリー別商品按分マスター'
                        ,	link:	'/headMasterDistribution'
                        }
                    ,	{
                            name:	'製造時間帯マスター'
                        ,	link:	'/headMasterProductionTimeSlot'
                        }
                    ,	{
                            name:	'生産計画カレンダーマスター'
                        ,	link:	'/headMasterStoreCalenderList'
                        }
                    ,	{
                            name:	'分類マスター'
                        ,	link:	'/headMasterClass'}
                    ,	{
                            name:	'店舗マスター'
                        ,	link:	'/headMasterStores'
                        }
                    ,	{
                            name:	'地区マスター'
                        ,	link:	'/headMasterArea'
                        }
                    ,	{
                            name:	'店舗グループマスター'
                        ,	link:	'/headMasterStoreGroups'
                        }
                    ,	{
                            name:	'曜日別入荷不可マスター'
                        ,	link:	'/headMasterNotAvailableDay'
                        }
                    ,	{
                            name:	'特売マスター'
                        ,	link:	'/headMasterSale'
                        }
                    ,	{
                            name:	'主要単品マスター'
                        ,	link:	'/headMasterMainSingle'
                        }
                    ,	{
                            name:	'取引先マスター'
                        ,	link:	'/headMasterVendor'
                        }
                    ,	{
                            name:	'販促区分マスター'
                        ,	link:	'/headMasterSalesPromotion'}
                    ,	{
                            name:	'定量発注マスター'
                        ,	link:	'/headMasterFixedOrderQuantity'
                        }
                    ,	{
                            name:	'定量生産マスター'
                        ,	link:	'/headMasterFixedProductItems'
                        }
                    ,	{
                            name:	'店休日マスター'
                        ,	link:	'/headMasterStoreHolidays'
                        }
                    ,	{
                            name:	'予算マスター'
                        ,	link:	'/headMasterBudget'
                        }
                    ,	{
                            name:	'ロス率マスター'
                        ,	link:	'/headMasterLossRatio'
                        }
                    ,	{
                            name:	'ユーザーマスター'
                        ,	link:	'/masterUsers'
                        }
                    ,	{
                            name:	'エリアマスター'
                        ,	link:	'/headMasterAllocateArea'
                        }
                    ,	{
                            name:	'アラートマスター'
                        ,	link:	'/headMasterAlert'
                        }
                    ,	{
                            name:	'天候マスター'
                        ,	link:	'/headMasterWeather'
                        }
                    ]
        }
    ,	{
            name:	'集計/照会'
        ,	list:	[
                        {
                            name:	'原料集約（期間指定）'
                        ,	link:	'/totalInquiryMaterialAggregationPeriods'
                        }
                    ,	{
                            name:	'原料集約（週間型）'
                        ,	link:	'/totalInquiryMaterialAggregationWeekly'
                        }
                    ,	{
                            name:	'店舗別仕入原価一覧'
                        ,	link:	'/totalInquiryStoresStockCostList'
                        }
                    ,	{
                            name:	'生産計画（商品別集計）'
                        ,	link:	'/totalInquiryProductionPlanningTotalItems'
                        }
                    ,	{
                            name:	'生産計画（店舗別集計）'
                        ,	link:	'/totalInquiryProductionPlanningTotalStore'
                        }
                    ,	{
                            name:	'生産計画（午前午後比集計）'
                        ,	link:	'/totalInquiryProductionPlanningAmPm'
                        }
                    ,	{
                            name:	'商品別店舗別集計'
                        ,	link:	'/totalInquiryTotalItemsAndStore'
                        }
                    ]
    }
    ,	{
            name:	'発注内示'
        ,	link:	'/unofficialNoticeOrder'
        }
    ,	{
            name:	'店舗生産計画'
        ,	link:	'/productionPlanning'
        }
    ,	{
         name:	'販売実績',
	link:	'/performanceSummary'
        }
    ,	{
         name:	'店舗管理',
	link:	'/mgrProgressCheck'
        }
    ]
    
,   STORE_MENU: [
        {
            name:	'生産計画'
        ,	link:	'/productionPlanning'
        }
 ,   {
         name:	'販売実績'
     ,	link:	'/performanceSummary'
     }
    ,	{	
            name:	'マスター'
        ,	list:	[
                        {
                            name:	'店休日マスター'
                        ,	link:	'/storeMasterStoreHolidays'
                        }
                    ,	{
                            name:	'予算マスター'
                        ,	link:	'/storeMasterBudget'
                        }
                    ,	{
                            name:	'ロス率マスター'
                        ,	link:	'/storeMasterLossRatio'
                        }
                    ,	{
                            name:	'ユーザーマスター'
                        ,	link:	'/masterUsers'
                        }
                    ]
        }
    ]
,   STORE_GENERAL_MENU: [
        {
            name:	'生産計画'
        ,	link:	'/productionPlanning'
        }
,   {
         name:	'販売実績'
     ,	link:	'/performanceSummary'
     }
    ]
}

export default MENU_LIST